/* eslint-disable @typescript-eslint/naming-convention */

export enum OverlayHeaderBannerAssetKey {
    BackgroundBanner = "background-banner",
    RightImage = "right-image",
}

export interface OverlayHeaderBannerAsset {
    asset_key: string;
    asset_value: string;
}

export interface OverlayHeaderBanner {
    type: string;
    key: string;
    title: string;
    subtitle: string;
    assets: OverlayHeaderBannerAsset[];
}

export interface LottieData {
    cart_type: string;
    header_lottie_config: {
        lotties: Array<Lottie>;
    };
    header_config?: LottieConfig;
    theme_config?: string;
    overlay_header_banner?: OverlayHeaderBanner;
}

export interface Lottie {
    lottie_id: string;
    type: string;
}

export interface FrequencyCapHeader {
    id: string;
    count?: number;
    session_count?: number;
}

export interface Delay {
    value: number;
    unit: string;
}

export interface ThemeConfig {
    header_gradient?: string;
    savings_banner_gradient?: string;
    savings_shimmer_gradient?: string;
    header_shadow?: string;
}

export interface LottieConfig {
    frequency_capping?: FrequencyCapHeader;
    delay?: Delay;
    delay_in_ms?: number;
    enable_frequency_cap?: boolean;
}

export interface HeaderLottieProps {
    lottieArray: Lottie[];
    cartType: string;
    showStampLottie?: boolean;
    showFinalState?: boolean;
    setHeaderLottieShown: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface HeaderStampLottieProps {
    lottieArray: Lottie[];
    cartType: string;
    showStampLottie?: boolean;
    showFinalState?: boolean;
    setHeaderStampLottieShown: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface LottieSectionProps {
    isRangeSla: boolean;
    isCartHeaderTypeLottie: boolean;
    cartType: string;
    lottieArray: Lottie[];
    isBolt: boolean;
    isExpress: boolean;
    isOtg: boolean;
    startAnimation: boolean;
    showFinalState: boolean;
    boltSla: number | null;
    setBoltOrExpressLottieShown: React.Dispatch<React.SetStateAction<boolean>>;
    setHeaderLottieShown: React.Dispatch<React.SetStateAction<boolean>>;
    isBlack: boolean;
}
